export enum InclinationType {
    // Core Drivers
    confidentAndBold,
    motivatedByRecognition,
    paceAndIntensity,
    relationshipDrive,
    stressManagement,
    externalOrientation,
    internalOrientation
}


// WEBPACK FOOTER //
// ./src/enums/InclinationType.tsx